<div class="wineRegionCard wineRegionCard--fixed cursor-pointer" *ngIf="wineRegion">
  <p-card>
    <ng-template pTemplate="header">
      <div
        class="headCard flex justify-content-between"
        [style.backgroundImage]="
          'url(' +
          (wineRegion?.headerImg?.src ||
            'https://res.cloudinary.com/divinea/image/upload/v1/production/cache/lgdkpct7hn0skbfbupgi.jpg') +
          ')'
        "
      ></div>
    </ng-template>

    <div class="wine-region-card__lower">
      <h3 class="wine-region-title text-ellipsis-2" [title]="wineRegion?.name">{{ wineRegion?.name }}</h3>
      <p class="wine-region-discover text-sm text-color-secondary m-0">{{ wineRegion?.discoverText }}</p>
      <p class="wine-region-desc text-ellipsis-2 m-0" *ngIf="wineRegion?.short_description">
        {{ wineRegion?.short_description }}
      </p>
      <div class="wine-region-footer winery flex justify-content-between align-items-center">
        <span class="text-sm nameCity">
          <i class="pi pi-map-marker" style="font-size: 0.9rem"></i>
          {{ wineRegion?.numExperiences }}+ esperienze
        </span>
      </div>
    </div>
  </p-card>
</div>
